import { useEffect, useState } from 'react'

import { InjectionTokens } from '@/controller/tokens'

import { Procedure } from '@/domain/protocols/Procedures'
import { ProceduresState } from '@/domain/states/ProceduresState'

import { MapProcedure } from '../components/MapProcedureChart/MapProcedureChart'

import { useInjection } from '@/presentation/contexts/InjectionContext'

function MapProcedurePresenter() {
  const proceduresState = useInjection<ProceduresState>(InjectionTokens.ProceduresState)
  const [procedure, setProcedure] = useState<Procedure>(null)

  useEffect(() => {
    const procedureChartStateSubscription = proceduresState.getState().subscribe((state) => {
      setProcedure(state.presentedProcedure)
    })

    return () => {
      procedureChartStateSubscription.unsubscribe()
    }
  }, [proceduresState])

  // Keyed by chart so a newly presented chart starts fully opaque again.
  return (
    procedure && <MapProcedure key={procedure.imageFile} url={procedure.imageFile} boundaries={procedure.boundaries} />
  )
}

export { MapProcedurePresenter }
